module.exports = __webpack_public_path__ + "static/Wisniowski-96d34d3d4650514ea84839a41bbbb787.svg";